import routeNames from './routeNames';
import routes, { protectedRoutes } from './routes';
import store from '@/store';
import { prependNamespace, namespace } from '@/store/modules/researcherSignup';
import * as types from '@/store/types';
import Api from '@/utils/api';
import * as Segment from '@/utils/segment';
import * as Tracking from 'Shared/helpers/tracking';
import _ from 'lodash';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({ routes, mode: 'history', base: '/signup' });

router.beforeEach(async (to, from, next) => {
  if (to.name === from.name) {
    return next();
  }
  const { user } = store.state[namespace];
  if (!_.isEmpty(user)) {
    return next();
  }
  const isProtected = _.includes(protectedRoutes, to.name);

  try {
    const setFieldsMutation = prependNamespace(types.SET_FIELDS);
    const {
      data: { success, response: me },
    } = await Api.get('/dashboard/settings/me');
    if (isProtected && !success) {
      return next({ name: routeNames.home });
    }
    if (success) {
      Segment.identifyUser(_.get(me, 'id'));
      store.commit(setFieldsMutation, { user: me });
    }
  } catch (error) {
    if (isProtected) {
      return next({ name: routeNames.home });
    }
  }

  next();
});

router.afterEach((to) => {
  const routeName = _.defaultTo(to.name, routeNames.home);
  Tracking.trackPageView(`Signup - ${routeName}`, { ga: true, segment: true });
});

export default router;
